// RetornoPago.jsx
//
// Flow devuelve al médico a `<FRONTEND_BASE_URL>/perfil?pago=flow` (R24 del
// backend). Al montar la app con ese parámetro se abre el diálogo en modo
// resultado: sondea `/api/user/me/` cada 3 s hasta 60 s y dice "Listo" o
// "Pendiente" (R31). El parámetro se limpia de la URL para que recargar la
// página no reabra el diálogo. Cubre R31 — .claude/specs/1680-cobro-internacional/
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckoutDialog from "./CheckoutDialog";

const RetornoPago = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("pago") !== "flow") return;
    setAbierto(true);
    params.delete("pago");
    const resto = params.toString();
    navigate(
      { pathname: location.pathname, search: resto ? `?${resto}` : "", hash: location.hash },
      { replace: true }
    );
  }, [location.search, location.pathname, location.hash, navigate]);

  if (!abierto) return null;
  return (
    <CheckoutDialog
      open
      faseInicial="confirmando"
      rielInicial="flow"
      onClose={() => setAbierto(false)}
    />
  );
};

export default RetornoPago;
